import React, { useEffect } from 'react';

interface GlobalErrorHandlerProps {
  // QA/QC FIX: [HIGH] - Unsafe any type in error handler interface bypassing type safety
  // LOGIC ISSUE: Using 'any' type for error logging bypasses TypeScript type checking and reduces code quality
  // SOLUTION: Define proper error interface with specific types:
  // interface ErrorDetails { message: string; source?: string; lineno?: number; colno?: number; error?: Error; stack?: string; }
  // logError: (error: ErrorDetails) => void;
  // IMPACT: Runtime errors from incorrect error object structure, debugging difficulties, reduced type safety
  // eslint-disable-next-line
  logError: (error: any) => void;
}

const GlobalErrorHandler: React.FC<GlobalErrorHandlerProps> = ({ logError }) => {

  useEffect(() => {
    // QA/QC FIX: [HIGH] - Unsafe any type in window error handler bypassing type safety
    // LOGIC ISSUE: Using 'any' type for error message bypasses TypeScript type checking and can cause runtime errors
    // SOLUTION: Use proper type union for error messages:
    // const handleWindowError = (message: string | Event, source?: string, lineno?: number, colno?: number, error?: Error) => {
    // IMPACT: Runtime errors from unexpected message types, reduced debugging capabilities
    // eslint-disable-next-line
    const handleWindowError = (message: any, source?: string, lineno?: number, colno?: number, error?: Error) => {

      // NOTE: react throws these exceptions twice, which folks talk about online but I can't find a great way to work around
      // ignoring the problem since this is purely a debugging resource
      // QA/QC FIX: [MEDIUM] - Potential sensitive data exposure in error logging
      // LOGIC ISSUE: Error logging may expose sensitive information like user data, API keys, or internal state
      // SOLUTION: Sanitize error messages before logging in production:
      // const sanitizedMessage = production ? sanitizeErrorMessage(message) : message;
      // Only log whitelisted error properties in production environment
      // IMPACT: Data privacy violations, security vulnerabilities, HIPAA compliance issues
      logError({ message, source, lineno, colno, error });
      return true;
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      // QA/QC FIX: [MEDIUM] - Unhandled promise rejection logging security vulnerability
      // LOGIC ISSUE: Promise rejection logging may expose sensitive data or internal application state without sanitization
      // SOLUTION: Sanitize rejection reasons before logging:
      // const sanitizedReason = sanitizePromiseRejection(event.reason);
      // Add error categorization and filtering for production environments
      // Implement rate limiting to prevent log spam attacks
      // IMPACT: Data privacy violations, security information disclosure, potential HIPAA violations
      logError({ message: event.reason.message, source: event.reason.stack });
    };

    window.onerror = handleWindowError;
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.onerror = null;
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, [logError]);

  return null;
};

export default GlobalErrorHandler;
